/*
  Sail Workshop — otomatik/kademeli ürün yükleme.

  Buton Liquid'de gerçek bir <a> (href = sonraki sayfa); JS yoksa normal sayfa geçişi olur.
  JS varsa: butona yaklaşıldığında bir sonraki sayfa yüklenir.

  Tetikleme, IntersectionObserver yerine doğrudan kaydırma mesafesiyle ölçülür —
  daha öngörülebilir ve ilk kaydırmada da güvenilir şekilde çalışır.
  Her yükleme tek başına yapılır; zincirleme tetikleme yoktur.
*/
(function () {
  var HARD_LIMIT = 60;      // güvenlik sınırı
  var TRIGGER_PX = 500;     // butona bu kadar yaklaşınca yükle
  var COOLDOWN_MS = 600;    // iki yükleme arası en az bekleme

  function init() {
    document.querySelectorAll('[data-load-more]').forEach(setup);
  }

  function findContainer(link) {
    return link.closest('#ProductGridContainer') || link.closest('.collection') || link.closest('.section') || document.body;
  }

  function findGrid(scope) {
    // Bazı şablonlarda #product-grid bir <div> ve içinde hem ürün listesi hem
    // sayfalama bulunur; ürünleri doğrudan listeye eklemek için <ul> tercih edilir.
    // Arama sayfasında birden fazla #product-grid olabilir (boş durum + sonuçlar),
    // bu yüzden içinde gerçekten ürün olanı seçeriz.
    var candidates = [].slice.call(scope.querySelectorAll('#product-grid, .collection-list, ul.grid'));
    var best = null;

    candidates.forEach(function (el) {
      var list = el.matches('ul') ? el : el.querySelector('ul');
      if (!list) return;
      if (!best || list.children.length > best.children.length) best = list;
    });

    return best;
  }

  function setup(link) {
    if (link.dataset.bound === 'true') return;
    link.dataset.bound = 'true';

    var container = findContainer(link);
    var grid = findGrid(container);
    if (!grid) return;

    // Sayfalama blokları JS devraldığında gereksiz: gizle.
    // (CSS ile yapılamıyor çünkü her şablonda sarmalayıcı farklı.)
    function hidePagination() {
      container.querySelectorAll('.pagination-wrapper').forEach(function (el) {
        el.style.display = 'none';
      });
    }

    var loading = false;
    var loads = 0;
    var lastLoad = 0;
    var ticking = false;

    function nearBottom() {
      if (!link.parentNode) return false;
      var rect = link.getBoundingClientRect();
      // Buton görünür alanın altından TRIGGER_PX kadar yakınsa
      return rect.top - window.innerHeight < TRIGGER_PX;
    }

    function maybeLoad() {
      if (loading || loads >= HARD_LIMIT) return;
      if (Date.now() - lastLoad < COOLDOWN_MS) return;
      if (!nearBottom()) return;
      load();
    }

    function load() {
      var url = link.getAttribute('href');
      if (loading || !url) return;

      loading = true;
      loads += 1;
      lastLoad = Date.now();
      var label = link.textContent;
      link.textContent = link.dataset.loadingText || 'Loading…';
      link.setAttribute('aria-busy', 'true');

      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var newGrid = findGrid(doc.querySelector('#ProductGridContainer') || doc.body);
          if (newGrid) {
            grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
            // Yeni gelen içerikle birlikte sayfalama da eklendiyse kaldır
            grid.querySelectorAll('.pagination-wrapper').forEach(function (el) {
              el.parentNode.removeChild(el);
            });
          }
          hidePagination();

          var nextLink = doc.querySelector('[data-load-more]');
          if (nextLink && nextLink.getAttribute('href')) {
            link.setAttribute('href', nextLink.getAttribute('href'));
          } else if (link.parentNode) {
            link.parentNode.removeChild(link);
          }
          window.history.replaceState({}, '', url);
        })
        .catch(function (error) {
          console.error('Ürünler yüklenemedi, sayfaya gidiliyor:', error);
          window.location.href = url;
        })
        .then(function () {
          loading = false;
          lastLoad = Date.now();
          if (link.parentNode) {
            link.textContent = label;
            link.removeAttribute('aria-busy');
          }
          // Zincirleme yükleme yok: bir sonraki tetikleme kullanıcının
          // kaydırmasıyla ya da bekleme süresi sonrası tek kontrolle olur.
        });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        maybeLoad();
      });
    }

    link.addEventListener('click', function (event) {
      event.preventDefault();
      lastLoad = 0;
      load();
    });

    hidePagination();

    // Filtre sonrası yeniden gelen sayfalamayı da gizle
    var repaint = new MutationObserver(hidePagination);
    repaint.observe(container, { childList: true, subtree: true });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Sayfa ilk açıldığında ekran ürünlerle dolmadıysa bir kez kontrol et
    window.setTimeout(maybeLoad, 400);
  }

  function start() {
    init();

    // Filtre uygulandığında tema ürün alanını baştan yazıyor; yeni gelen
    // butona ve sayfalamaya tekrar bağlanmak için DOM değişimini izle.
    var container = document.getElementById('ProductGridContainer') || document.body;
    var observer = new MutationObserver(function () { init(); });
    observer.observe(container, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
